import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var EditPortfolioAction = function () {

}


EditPortfolioAction.prototype = {

	editPortfolio: function (data) {

		restClient.editPortfolio(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.EDIT_PORTFOLIO,
						data: error
					});
				}
			} else {
				response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.EDIT_PORTFOLIO,
					data: response
				});
			}
		})
	}
}

export default new EditPortfolioAction();